import { gql } from '@apollo/client/core'

const PURCHASE_ONE_TIME_PAYMENT = gql`
  mutation checkoutOneTimePayment(
    $email: String!
    $fullName: String!
    $phoneNumber: String
    $providerPaymentMethodId: String!
    $providerPromotionCodeId: String
    $purchasableItems: [PurchasableItem!]!
    $metadata: [KeyValueString!]
  ) {
    checkoutOneTimePayment(
      email: $email
      fullName: $fullName
      phoneNumber: $phoneNumber
      providerPaymentMethodId: $providerPaymentMethodId
      providerPromotionCodeId: $providerPromotionCodeId
      purchasableItems: $purchasableItems
      metadata: $metadata
    ) {
      runId
      subjectId
      kind
      state
      errorMessage
    }
  }
`

export default PURCHASE_ONE_TIME_PAYMENT
